import React, { Component } from "react";

class InputFieldError extends Component {
  render() {
    return <font color="red">{this.props.touched && this.props.error}</font>;
  }
}

export default InputFieldError;
